import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

import { formatPrice } from "../utils/helpers";

const Product = (props: any) => {
  const { brand, image_url, name, price, category, id } = props;
  return (
    <Wrapper>
      <Link to={`/products/${id}`}>
        <div className="container">
          <img src={image_url} alt={name} />
        </div>
        <div>
          <p className="product-name">{`${brand} ${name}`}</p>
          <p className="product-price">{formatPrice(price)}</p>
        </div>
      </Link>
    </Wrapper>
  );
};

const Wrapper = styled.article`
  height: 100%;

  .container {
    height: 100%;
  }

  img {
    width: 100%;
    height: 100%;
    background: #f5f5f5;
    object-fit: contain;
  }
  p {
    font-family: HelveticaNeue-Medium;
    font-size: 18px;
    color: #090a0a;
    margin: 0.8rem 0;
  }
  a {
    text-decoration: none;
  }
  .product-price {
    font-size: 16px;
  }
`;

// #F4F0EC

export default Product;
